// extracted by mini-css-extract-plugin
module.exports = {"interactive-icons":"PortalInput_interactive-icons__UA6hr","interactive-icon-copy":"PortalInput_interactive-icon-copy__1ffGe"};